import React, { useState, useMemo, useEffect } from 'react';
import { X, Download } from 'lucide-react';
import { Sheet, SheetContent } from '../../../components/ui/sheet';
import { Button } from '../../../components/ui';
import { useTranslation } from 'react-i18next';
import { ActivityLog } from '../Shared/ActivityLog';
import { filterActivitiesByType, MOCK_ACTIVITIES } from '../../../utils/mockActivityLogData';
import './ActivityLogDrawer.css';

const ACTION_FILTERS = [
  { id: 'all', key: 'reports.workspace.activityLogDrawer.filters.all' },
  { id: 'created', key: 'reports.workspace.activityLogDrawer.filters.created' },
  { id: 'edited', key: 'reports.workspace.activityLogDrawer.filters.edited' },
  { id: 'locked', key: 'reports.workspace.activityLogDrawer.filters.locked' },
  { id: 'status_changed', key: 'reports.workspace.activityLogDrawer.filters.statusChanged' },
  { id: 'commented', key: 'reports.workspace.activityLogDrawer.filters.commented' },
];

export function ActivityLogDrawer({ isOpen, onClose, activities = [] }) {
  const { t } = useTranslation();
  const [selectedFilter, setSelectedFilter] = useState('all');
  
  // Use mock activities if none provided
  const allActivities = activities.length > 0 ? activities : MOCK_ACTIVITIES;
  
  // Sort by timestamp (newest first)
  const sortedActivities = useMemo(() => {
    return [...allActivities].sort((a, b) => {
      const dateA = new Date(a.timestamp);
      const dateB = new Date(b.timestamp);
      return dateB - dateA;
    });
  }, [allActivities]);
  
  const filteredActivities = useMemo(() => {
    return filterActivitiesByType(sortedActivities, selectedFilter);
  }, [sortedActivities, selectedFilter]);

  const handleExport = () => {
    // Mock export functionality
    console.log('Exporting activity log...');
  };

  // Debug logging
  React.useEffect(() => {
    console.log('ActivityLogDrawer isOpen:', isOpen);
  }, [isOpen]);

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="activity-log-drawer" style={{ width: '600px', zIndex: 1000 }}>
        {/* Header */}
        <div className="activity-log-drawer__header">
          <h2 className="activity-log-drawer__title">{t('reports.workspace.activityLogDrawer.title')}</h2>
          <div className="activity-log-drawer__header-actions">
            <select
              className="activity-log-drawer__filter"
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.target.value)}
            >
              {ACTION_FILTERS.map((filter) => (
                <option key={filter.id} value={filter.id}>
                  {t(filter.key)}
                </option>
              ))}
            </select>
            <Button
              variant="outline"
              size="sm"
              onClick={handleExport}
              disabled
              className="activity-log-drawer__export-btn"
            >
              <Download size={14} />
              {t('common.export')}
            </Button>
            <button
              className="activity-log-drawer__close-btn"
              onClick={onClose}
              aria-label={t('common.close')}
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Activity Log */}
        <ActivityLog activities={filteredActivities} />
      </SheetContent>
    </Sheet>
  );
}
